// src/services/reviewService.js - Updated for MongoDB backend
import api from './api';

// Bewertungen für einen Shop abrufen (nur genehmigte)
export const getShopReviews = async (shopId) => {
    try {
        if (!shopId) {
            return {
                success: false,
                message: 'Shop-ID ist erforderlich',
                data: []
            };
        }
        const response = await api.get(`/reviews/shop/${shopId}`);
        return response; // Das api-Objekt behandelt bereits success/error
    } catch (error) {
        console.error('Error fetching shop reviews:', error);
        // Gib den Fehler weiter, damit die aufrufende Komponente ihn behandeln kann
        return { 
            success: false, 
            message: error.response?.data?.message || error.message || 'Fehler beim Laden der Bewertungen', 
            data: [] 
        };
    }
};

// Neue Bewertung erstellen (kann von Gast oder User sein)
export const createReview = async (reviewData) => {
    try {
        // Grundlegende Frontend-Validierung (wird auch im Backend geprüft)
        if (!reviewData.shop || !reviewData.rating || !reviewData.text || (!reviewData.author && !localStorage.getItem('token'))) {
            return {
                success: false,
                message: 'Shop, Bewertung, Text und (als Gast) Name sind erforderlich'
            };
        }
        const response = await api.post('/reviews', reviewData);
        return response;
    } catch (error) {
        console.error('Error creating review:', error);
        return { 
            success: false, 
            message: error.response?.data?.message || error.message || 'Fehler beim Erstellen der Bewertung' 
        };
    }
};

// Bewertung aktualisieren (nur eigene oder Admin)
export const updateReview = async (id, reviewData) => {
    try {
        if (!id) {
            return { success: false, message: 'Bewertungs-ID ist erforderlich' };
        }
        // Im Backend wird geprüft, ob rating/text vorhanden sind
        const response = await api.put(`/reviews/${id}`, reviewData);
        return response;
    } catch (error) {
        console.error('Error updating review:', error);
        return { 
            success: false, 
            message: error.response?.data?.message || error.message || 'Fehler beim Aktualisieren der Bewertung' 
        };
    }
};

// Bewertung löschen (nur eigene oder Admin)
export const deleteReview = async (id) => {
    try {
        if (!id) {
            return { success: false, message: 'Bewertungs-ID ist erforderlich' };
        }
        const response = await api.delete(`/reviews/${id}`);
        return response;
    } catch (error) {
        console.error('Error deleting review:', error);
        return { 
            success: false, 
            message: error.response?.data?.message || error.message || 'Fehler beim Löschen der Bewertung' 
        };
    }
};

// --- Admin Funktionen ---

// Ausstehende Bewertungen abrufen (Admin only)
export const getPendingReviews = async () => {
    try {
        const response = await api.get('/reviews/pending');
        return response;
    } catch (error) {
        console.error('Error fetching pending reviews:', error);
        return { 
            success: false, 
            message: error.response?.data?.message || error.message || 'Fehler beim Laden der ausstehenden Bewertungen' 
        };
    }
};

// Bewertung genehmigen (Admin only)
export const approveReview = async (id) => {
    try {
        if (!id) {
            return { success: false, message: 'Bewertungs-ID ist erforderlich' };
        }
        const response = await api.put(`/reviews/${id}/approve`);
        return response;
    } catch (error) {
        console.error('Error approving review:', error);
        return { 
            success: false, 
            message: error.response?.data?.message || error.message || 'Fehler beim Genehmigen der Bewertung' 
        };
    }
};